import { apiAdmin } from './cliente';

/**
 * GET /api/v1/capabilities/me?tenantSlug={slug}
 * Retorna a lista de capability codes habilitados para o usuário autenticado no tenant.
 */
export const obterCapabilitiesMe = (tenantSlug) =>
  apiAdmin.get('/api/v1/capabilities/me', {
    params: { tenantSlug },
  });
